export default __webpack_public_path__ + "static/media/cisoo.e5792e2b.png";